<template>
  <a-modal
    title="物流投诉"
    :visible.sync="visible"
    :width="560"
    @cancel="cancel"
  >
    <div v-if="info" class="complaint">
      <div class="flex fslh-32"><div class="w-70 t-right">快递单号：</div><div>{{ info.logisticCode }}</div></div>
      <div class="flex fslh-32"><div class="w-70 t-right">订单号：</div><div>{{ info.kdnOrderCode }}</div></div>
      <div class="flex fslh-32"><div class="w-70 t-right">快递公司：</div><div>{{ info.shipperName }}</div></div>
      <div class="flex fslh-32"><div class="w-70 t-right">投诉类型：</div><div class="flex flex1 flex-wrap "><div v-for="(i,index) in opts" :key="i.code" :class="sIndex===index?'c-active':''" class="mr-10 type mb-10" @click="sIndex = index">{{ i.name }}</div></div></div>
      <div class="flex fslh-32"><div class="w-70 t-right">问题描述：</div><div class="flex1"><a-input v-model="params.ticketContent" class="w-100p" placeholder="添加备注（50个字以内）" /></div></div>
      <div class="flex fslh-32 mt-20"><div class="w-70 t-right">附件：</div>
        <div class="flex1 clearfix">
          <a-upload
            :action="uploadURL"
            list-type="picture-card"
            :file-list="fileList"
            :headers="{token:$getToken()}"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="fileList.length < 8">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
            <img alt="example" style="width: 100%" :src="previewImage">
          </a-modal>
        </div>
      </div>
    </div>
    <div slot="footer" class="t-right"><a-button @click="visible = false">取 消</a-button> <a-button type="primary" @click="ok">确 认</a-button></div>
  </a-modal>
</template>
<script>
// import request from 'ant-design-vue/lib/vc-upload/src/request'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      previewImage: '',
      previewVisible: false,
      uploadURL: process.env.VUE_APP_BASE_API + '/upload/singleFile.json',
      //   visible: true
      showForm: false,
      list: [],
      opts: [],
      fileList: [],
      sIndex: '',
      params: {
        'ticketName': '',
        'ticketMobile': '',
        'kdnOrderCode': '',
        'logisticCode': '',
        'orderCode': '',
        'shipperCode': '',
        'ticketContent': '',
        'ticketPic': '',
        'ticketType': 0
      }
    }
  },
  watch: {
    async visible(n) {
      this.$emit('update:visible', n)
    }
  },
  async created() {
    const res = await this.$http(this.$api.complaintGetTypeList)
    this.opts = res
  },
  methods: {
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    // customRequest(opts) {
    //   const success = opts.onSuccess
    //   opts.onSuccess = function() {
    //     const res = { ...arguments[0] }
    //     arguments[0] = {
    //       uid: res.data.fileName, // unique identifier, negative is recommend, to prevent interference with internal generated id
    //       name: res.data.fileName, // file name
    //       status: 'done', // options：uploading, done, error, removed
    //       response: res.data, // response from server
    //       xhr: arguments[1] // XMLHttpRequest Header
    //     }
    //     success.apply(this, arguments)
    //   }
    //   request(opts)
    // },
    handleChange({ fileList }) {
      this.fileList = fileList
    //   console.log(fileList)
    //   const res = fileList && fileList[fileList.length - 1].response
    //   if (res && res.data && res.data.filePath) {
    //     this.fileList = fileList
    //   } else if (res && res.data && res.data.message) {
    //     this.$message.warning(res.data.message)
    //   } else {
    //     this.$message.error('上传错误')
    //   }
    },
    async ok() {
      if (!this.opts[this.sIndex]) {
        this.$message.error('请选择投诉类型')
        return
      }
      if (!this.params.ticketContent) {
        this.$message.error('问题描述不能为空')
        return
      }
      const file = this.fileList.find(el => {
        return !el.response || !el.response.data || !el.response.data.filePath
      })
      if (file) {
        this.$message.error(file.response && file.response.data && file.response.data.message || '上传错误')
        return
      }
      this.params.kdnOrderCode = this.info.kdnOrderCode
      this.params.orderCode = this.info.orderCode
      this.params.ticketName = this.info.fromName
      this.params.logisticCode = this.info.logisticCode
      this.params.ticketMobile = this.info.fromMobile
      this.params.ticketPic = this.fileList.map(el => {
        if (el.response && el.response.data && el.response.data.filePath) {
          return el.response.data.filePath
        }
      }).join(',')
      this.params.shipperCode = this.info.shipperCode
      this.params.ticketType = +this.opts[this.sIndex].code
      const res = await this.$http({ ...this.$api.complaintAdd, origin: true }, {
        ...this.params
      })
      if (res.data.state === 'success') {
        this.$message.success('提交投诉成功')
        this.$emit('success')
      } else {
        console.log(res.data.msg)
        this.$message.error(res.data.msg)
      }
    },
    cancel() {
      this.$emit('update:visible', false)
    //
    }
  }
}
</script>
<style lang="scss">
.complaint{
    .type{
        cursor: pointer;
        border:1px solid rgba(0,0,0,0.15);
        border-radius: 2px;
        padding: 0 8px;
    }
}
</style>
